
import {
  Vue,
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Button,
  Input,
} from 'element-ui';
import api from '@/api/match';
import Draggable from 'vuedraggable';

@Component({
  components: {
    Form,
    FormItem,
    Button,
    Input,
  },
})

export default class secondStep extends Vue {
  @Prop({
    required: true,
    default: false,
  }) oldForm!: any;

  private form: any = {};


  private rules: any = {}

  public $refs!: {
    form: Form,
  };

  mounted() {
    if (this.oldForm.scratchVersion === 2) {
      const {
        backdropLibrary,
        costumeLibrary,
        soundLibrary,
        spriteLibrary,
      } = this.oldForm;
      this.form = {
        backdropLibrary,
        costumeLibrary,
        soundLibrary,
        spriteLibrary,
      };
    } else {
      const {
        backdropLibrary: V3BackdropLibrary,
        costumeLibrary: V3CostumeLibrary,
        soundLibrary: V3SoundLibrary,
        spriteLibrary: V3SpriteLibrary,
      } = this.oldForm;
      this.form = {
        V3BackdropLibrary,
        V3CostumeLibrary,
        V3SoundLibrary,
        V3SpriteLibrary,
      };
    }
  }

  /**
   * @author liangyongmou
   * @desc 提交
   * @param 空
   */
  handleSubmit() {
    // eslint-disable-next-line array-callback-return
    let result:any = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        result = this.form;
      }
    });
    return result;
  }
}
